import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotLoggedInMasterComponent } from './components/layout/not-loggedin/not-loggedin.master';
import { MemberJoinComponent } from './views/member-join/member-join.component';
import { environment } from 'src/environments/environment';
import { MemberJoinOfflineComponent } from './views/member-join-offline/member-join-offline.component';

const isOffline: boolean = environment.isOffline === "true";

var routes: Routes = !isOffline
  ? [
    {
      path: '',
      component: NotLoggedInMasterComponent,
      children: [
        {
          outlet: 'master',
          path: '',
          component: MemberJoinComponent,
        },
      ],
      pathMatch: 'full',
    },
    {
      path: '**',
      redirectTo: '',
    },
  ]
  : [
    {
      path: '',
      component: NotLoggedInMasterComponent,
      children: [
        {
          outlet: 'master',
          path: '',
          component: MemberJoinOfflineComponent,
        },
      ],
      pathMatch: 'full',
    },
  ];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
